/**
 * Gold pulsing halos drawn over every grid cell that is a valid pick
 * target while a two-step location effect is pending (Ancient Dragon,
 * Vikings, Midland Army, etc.).
 *
 * One DOM node per cell key, position +
 * size mutated each frame by GameBoard.updateCellTargetOverlays.
 * React only re-renders when the cellKeys array itself changes.
 */
export default function CellTargetOverlays({ cellKeys, registerRefs }) {
  const keys = Array.from(cellKeys || []);
  if (keys.length === 0) return null;

  return (
    <div aria-hidden="true">
      {keys.map((key) => (
        <Halo key={key} cellKey={key} registerRefs={registerRefs} />
      ))}
    </div>
  );
}

function Halo({ cellKey, registerRefs }) {
  const setHalo = (el) => registerRefs(cellKey, el);
  return <div ref={setHalo} className="cell-target-halo" />;
}
